import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { blogService, imageService } from '../services';
import Header from './Header';

const BlogDetail = () => {
  const { slug } = useParams();
  const [blogData, setBlogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    const fetchBlogData = async () => {
      try {
        const res = await blogService.getBySlug(slug);
        setBlogData(res?.data || null);
        if (res?.data?.title) {
          document.title = res.data.title;
        }
      } catch (err) {
        setError('Không tìm thấy thông tin blog!');
      } finally {
        setLoading(false);
      }
    };
    fetchBlogData();
  }, [slug]);

  if (loading) return <div>Đang tải...</div>;
  if (error) return <div>{error}</div>;
  if (!blogData) return <div>Không có dữ liệu blog.</div>;

  return (
    <>
      <Header />
      <div className="blog-detail-container">
        <div className="blog-detail-box">
          {blogData.thumbnailPath && (
            <img
              src={imageService.getThumbnail(blogData.thumbnailPath)}
              alt={blogData.title}
              className="blog-detail-thumbnail"
            />
          )}
          <h1 className="blog-detail-title">{blogData.title}</h1>
          {blogData.createDate && (
            <div className="blog-detail-date" style={{marginBottom: 18, textAlign: 'left'}}>
              {new Date(blogData.createDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
            </div>
          )}
          <PopularNowBar />
          {blogData.description && (
            <div className="blog-detail-desc">{blogData.description}</div>
          )}
          <div
            className="blog-detail-content"
            dangerouslySetInnerHTML={{ __html: blogData.content }}
            style={{ textAlign: 'left' }}
          />
        </div>
      </div>
    </>
  );
};

// PopularNowBar: hiển thị danh sách game popular-now
const PopularNowBar = () => {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPopularNow = async () => {
      try {
        const res = await import('../services').then(m => m.gameReviewService.getPopularNow());
        setGames(res?.data?.content || []);
      } catch (err) {
        setError('Không thể tải danh sách hot games');
      } finally {
        setLoading(false);
      }
    };
    fetchPopularNow();
  }, []);

  if (loading) return <div style={{ margin: '16px 0', color: '#888' }}>Loading hot games...</div>;
  if (error) return <div style={{ margin: '16px 0', color: 'red' }}>{error}</div>;
  if (!games.length) return null;

  return (
    <div className="popular-now-bar" style={{ margin: '0 0 32px 0' }}>
      <div style={{ fontWeight: 700, fontSize: 24, color: '#181512', marginBottom: 18, textAlign: 'left' }}>Popular Now</div>
      <div className="popular-now-list" style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 14,
        alignItems: 'flex-start',
      }}>
        {games.map((game, idx) => (
          <div
            key={game.id || idx}
            className="popular-now-item"
            style={{
              display: 'flex',
              alignItems: 'center',
              background: '#fff',
              borderRadius: 12,
              boxShadow: '0 2px 12px 0 rgba(0,0,0,0.07)',
              padding: '7px 16px 7px 10px',
              minHeight: 40,
              cursor: 'pointer',
              transition: 'box-shadow 0.18s, transform 0.18s',
              fontWeight: 600,
              fontSize: 16,
              color: '#222',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              marginBottom: 6,
              maxWidth: 1000,
            }}
            onClick={() => game.slug && window.open(`/get-game/${game.slug}`, '_self')}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 16px 0 rgba(16,166,199,0.13)'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 12px 0 rgba(0,0,0,0.07)'}
          >
            <img
              src={require('../services').imageService.getThumbnail(game.thumbnailPath)}
              alt={game.title}
              style={{ width: 32, height: 32, borderRadius: 8, objectFit: 'cover', marginRight: 8, background: '#eee', flexShrink: 0 }}
            />
            <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{game.title}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BlogDetail; 